import { getPrivacyPolicy, getImpressum, getInitialInfo, getTermsAndConditions } from "./getLegalDocument";
import { Logger } from "./logger";
import { buildLegalLink } from "./legalLinkUtils";

export async function injectFooterIntoDefaultPage(companyName?: string): Promise<void> {
    Logger.info("📎 Baue Footer für Default-Landingpage...");

    const container = document.querySelector(".footer");
    if (!container) {
        Logger.warn("❌ Kein Footer-Container gefunden.");
        return;
    }

    const [privacy, impressum, initialInfo, agb] = await Promise.all([
        getPrivacyPolicy(),
        getImpressum(),
        getInitialInfo(),
        getTermsAndConditions()
    ]);

    const links: string[] = [];

    if (impressum?.trim()) links.push(`<a href="${buildLegalLink('/legalpages/impressum.html')}">Impressum</a>`);
    if (privacy?.trim()) links.push(`<a href="${buildLegalLink('/legalpages/datenschutz.html')}">Datenschutz</a>`);
    if (agb?.trim()) links.push(`<a href="${buildLegalLink('/legalpages/agb.html')}">AGB</a>`);
    if (initialInfo?.trim()) links.push(`<a href="${buildLegalLink('/legalpages/erstinformation.html')}">Erstinformation</a>`);

    const linksHtml = links.length > 0 ? `<p>${links.join(" | ")}</p>` : "";

    container.innerHTML = `
        <p>&copy; 2025 ${companyName ?? ""}. Alle Rechte vorbehalten.</p>
        ${linksHtml}
    `;

    Logger.info("✅ Footer fertig mit Links:", links);
}
